import { render } from "./UserPage_loan.vue?vue&type=template&id=91d77f74&scoped=true"
import script from "./UserPage_loan.vue?vue&type=script&lang=js"
export * from "./UserPage_loan.vue?vue&type=script&lang=js"

import "./UserPage_loan.vue?vue&type=style&index=0&id=91d77f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d77f74"]])

export default __exports__